import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { UsersList } from "../../core/models/users/users/usersList";
import { ProfileFormService } from "../../core/services/profile-form.service";
import { UserSupportMapComponent } from "./components/user-support-map/user-support-map.component";
import { SharedService } from "../../core/services/shared.service";
import { ProfileFormComponent } from "./components/profile-form/profile-form.component";
import { CommonModule } from "@angular/common";
import { UserSupportMapService } from "../../core/services/user-support-map.service";
import { lastValueFrom } from "rxjs";
import { D365SynchronizerService } from "../../core/services/d365-synchronizer.service";
import {
  ToggleSwitchChangeEvent,
  ToggleSwitchModule,
} from "primeng/toggleswitch";
import { MenuModule } from "primeng/menu";
import { ButtonModule } from "primeng/button";
import { MenuItem } from "primeng/api";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  Validators,
} from "@angular/forms";
import { UpdateUserDto } from "../../core/models/users/users/UpdateUserDto";
import { UserRoleName } from "../../shared/enums/userRolesName.enum";
import { UserRoleType } from "../../core/models/users/userRoleType";
import { ConfirmUserEmailDto } from "../../core/models/users/users/confirmUserEmailDto";
import { GetUserDto } from "../../core/models/users/users/getUserDto";
import { ModalStackerComponent } from "../../shared/components/modal-stacker/modal-stacker.component";
import { JniToastrService } from "../../core/services/jni-toastr.service";
import { UsersListingService } from "../../core/services/users-listing.service";
import { UserSupportMap } from "../../core/models/profile/userSupport";
import { GenericResponseDto } from "../../core/models/generic-response.dto";
import { CardModule } from "primeng/card";

@UntilDestroy()
@Component({
  selector: "jni-profile",
  templateUrl: "./profile.component.html",
  standalone: true,
  imports: [
    ProfileFormComponent,
    CommonModule,
    UserSupportMapComponent,
    ToggleSwitchModule,
    MenuModule,
    ButtonModule,
    FormsModule,
    ModalStackerComponent,
    CardModule,
  ],
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent implements OnInit {
  @Input() userId = 0;
  @Input() isModal = false;
  userEmail!: string;
  profileForm: FormGroup;
  @Output() emitCloseProfileModal = new EventEmitter();

  @ViewChild("profileFormCom") profileFormCom!: ProfileFormComponent;

  constructor(
    private _route: ActivatedRoute,
    private _profileFormService: ProfileFormService,
    private router: Router,
    private _sharedService: SharedService,
    private _userSupportMapService: UserSupportMapService,
    private _usersListingService: UsersListingService,
    private _d365SynchronizerService: D365SynchronizerService,
    private _toastr: JniToastrService,
    private _formBuilder: FormBuilder
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.profileForm = this._formBuilder.group({
      id: [{ value: 0, disabled: true }],
      name: [{ value: "", disabled: false }, [Validators.required]],
      loginEmail: [{ value: "", disabled: true }],
      sendEmailAs: [
        { value: "", disabled: false },
        [Validators.required, Validators.email],
      ],
      employeeId: [{ value: "", disabled: false }, [Validators.required]],
      projectId: [{ value: "", disabled: false }],
      billerId: [{ value: "", disabled: false }],
      collectorId: [{ value: "", disabled: false }],
      displayEmailAs: [{ value: "", disabled: false }, [Validators.email]],
      locationName: [{ value: "", disabled: false }],
      displayPhoneNumber: [{ value: "", disabled: false }],
      title: [{ value: "", disabled: false }],
      primaryBACEmail: [{ value: "", disabled: true }],
      contactAddress: [{ value: "", disabled: false }],
      isProfileActive: [{ value: false, disabled: false }],
      isConfirmed: [{ value: false, disabled: false }],
      isLedgerActive: [{ value: false, disabled: false }],
      executiveLedgerAccess: [{ value: false, disabled: false }],
      managerAccess: [{ value: false, disabled: false }],
      userRoleId: [{ value: 0, disabled: false }],
      superManagerAccess: [{ value: false, disabled: false }],
      inventoryAccess: [{ value: false, disabled: false }],
      isBcIpEmailEnabled: [{ value: false, disabled: false }],
      isBacIpEmailEnabled: [{ value: false, disabled: false }],
      isBcCdiEmailEnabled: [{ value: false, disabled: false }],
      isBacCdiEmailEnabled: [{ value: false, disabled: false }],
    });
  }

  whoSupportMeTableData: UserSupportMap[] = [];
  whoSupportMeAddTableData: UsersList[] = [];

  whoISupportTableData: UserSupportMap[] = [];
  whoISupportAddTableData: UsersList[] = [];

  @ViewChild("whosupportsme", { static: false })
  whosupportsme!: UserSupportMapComponent;

  @ViewChild("whoisupport", { static: false })
  whoisupport!: UserSupportMapComponent;

  profileEmail = "";
  errorMessage = "Error occurred during synchronisation";
  successMessage = "Data synchronized successfully";
  queueSuccessMessage = "Sync in progress";
  currentRoleId = 0;
  confirmEmail: ConfirmUserEmailDto = new ConfirmUserEmailDto();
  getUserObject?: GenericResponseDto<GetUserDto>;
  isProfileActive = false;
  isProfileValid = false;
  items: MenuItem[] = [];
  selectedUserId = 0;
  userSupportProfileDisplayModal = false;

  roleType: UserRoleType[] = [
    {
      id: 4,
      name: UserRoleName.Sales,
      isSelected: false,
    },
    { id: 3, name: UserRoleName.PowerUse, isSelected: false },
    {
      id: 5,
      name: UserRoleName.VR,
      isSelected: false,
    },
    {
      id: 2,
      name: UserRoleName.Manager,
      isSelected: false,
    },
    {
      id: 1,
      name: UserRoleName.Admin,
      isSelected: false,
    },
  ];

  ngOnInit(): void {
    if (!this.userId || this.userId <= 0) {
      this._route.params.subscribe((params: Params) => {
        this.userId = params["id"];
      });
    }
    if (this.userId) {
      this._profileFormService.getUsersById(this.userId).subscribe({
        next: async res => {
          if (res.data != null) {
            this.userEmail = res.data.loginEmail;
            await this.getWhoSupportMeTable();
            await this.getWhoISupportTable();
            await this.getUsersListingData();
          }
        },
      });
    }

    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }

  refresIsPrimaryWhoSupportsMe() {
    this.getWhoSupportMeTable();
  }

  refresIsPrimaryDataWhoISupport() {
    this.getWhoISupportTable();
  }

  refreshTablForSelfUser(email: string) {
    this.userEmail = email;
    this.getWhoSupportMeTable();
    this.getWhoISupportTable();
  }

  async refreshWhoSupportsMeAddTable() {
    await this.getWhoSupportMeTable();
    await this.getUsersListingData();
  }

  async refreshWhoISupportAddTable() {
    await this.getWhoISupportTable();
    await this.getUsersListingData();
  }

  async getWhoSupportMeTable() {
    const res = await lastValueFrom(
      this._userSupportMapService
        .getWhoSupportMeTableRecord(this.userEmail)
        .pipe(untilDestroyed(this))
    );
    this.whoSupportMeTableData = res.data;
    this.whoSupportMeTableData.forEach(element => {
      if (this.isExpiredDateValidation(element.expiresOn ?? "")) {
        element.isActive = false;
      }
      element.expiresOn = element.expiresOn
        ? new Date(element.expiresOn)
        : null;
    });
  }

  async getWhoISupportTable() {
    const res = await lastValueFrom(
      this._userSupportMapService
        .getWhoISupportTableRecord(this.userEmail)
        .pipe(untilDestroyed(this))
    );
    this.whoISupportTableData = res.data;
    this.whoISupportTableData.forEach(element => {
      if (this.isExpiredDateValidation(element.expiresOn ?? "")) {
        element.isActive = false;
      }
      element.expiresOn = element.expiresOn
        ? new Date(element.expiresOn)
        : null;
    });
  }

  async getUsersListingData() {
    const res = await lastValueFrom(
      this._usersListingService
        .GetAllConfiguredUser()
        .pipe(untilDestroyed(this))
    );
    if (!res.data) {
      return;
    }

    const filtered = res?.data?.filter(
      ({ id }: { id: number }) =>
        !this.whoISupportTableData.some(({ userId }) => userId === id)
    );
    const filteredWhoSupportMe = res.data.filter(
      ({ id }: { id: number }) =>
        !this.whoSupportMeTableData.some(
          ({ supportUserId }) => supportUserId === id
        )
    );

    this.whoISupportAddTableData = filtered.filter(
      (x: UsersList) =>
        x.loginEmail !== this.userEmail &&
        x.userRoleName === "Sales" &&
        x.isLedgerActive === true &&
        x.isProfileActive === true
    );
    this.whoisupport.SupportUserList(this.whoISupportAddTableData);
    this.whoSupportMeAddTableData = filteredWhoSupportMe.filter(
      (x: UsersList) =>
        x.loginEmail !== this.userEmail && x.userRoleName === "Sales"
    );
    this.whosupportsme.SupportUserList(this.whoSupportMeAddTableData);
  }

  isExpiredDateValidation(expiredate: string | Date) {
    const date = new Date();
    if (date < new Date(expiredate)) {
      return false;
    } else {
      return true;
    }
  }

  syncD365Data() {
    //this.showSmallLoader = true;
    this._d365SynchronizerService
      .syncAllD365Data()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          //this.showSmallLoader = false;
          if (res.status == "Success") {
            this._toastr.success("Success", this.queueSuccessMessage);
          } else {
            this._toastr.error("Error", this.errorMessage);
          }
        },
        error: () => {
          //this.showSmallLoader = false;
          this._toastr.error("Error", this.errorMessage);
        },
      });
  }

  isIPEmailChecked() {
    const isBCIpEmail = this.profileForm?.get("isBcIpEmailEnabled")?.value;
    const isBacIpEmail = this.profileForm?.get("isBacIpEmailEnabled")?.value;
    if (!isBCIpEmail && !isBacIpEmail) {
      return false;
    } else {
      return true;
    }
  }

  isCDIEmailChecked() {
    const isBcCDIEmail = this.profileForm?.get("isBcCdiEmailEnabled")?.value;
    const isBacCDIEmail = this.profileForm?.get("isBacCdiEmailEnabled")?.value;
    if (!isBcCDIEmail && !isBacCDIEmail) {
      return false;
    } else {
      return true;
    }
  }

  updateUserProfileDataSilent() {
    const updateUserDto = this.profileForm.getRawValue() as UpdateUserDto;
    //this.showSmallLoader = true;
    this.roleType.forEach(element => {
      if (element.isSelected) {
        this.currentRoleId = element.id;
        updateUserDto.userRoleId = this.currentRoleId;
      }
    });

    const isIPchecked = this.isIPEmailChecked();
    if (!isIPchecked) {
      this._toastr.error(
        "Error",
        "At least one IP email notification must be selected"
      );
      //this.showSmallLoader = false;
      return;
    }

    const isCDIchecked = this.isCDIEmailChecked();
    if (!isCDIchecked) {
      this._toastr.error(
        "Error",
        "At least one CDI email notification must be selected"
      );
      //this.showSmallLoader = false;
      return;
    }

    this._profileFormService
      .updateUser(updateUserDto)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.updateConfirmEmail();
        },
        error: () => {
          this._toastr.error("Error", "Error updating user");
          //this._loaderService.setLoaderState(false);
        },
      });
  }

  updateConfirmEmail() {
    //this.showSmallLoader = true;
    this.confirmEmail.sendAsEmail = this.profileForm.get("sendEmailAs")?.value;
    this.confirmEmail.userId = this.userId;
    this._profileFormService
      .confirmEmail(this.confirmEmail)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._toastr.success("Success", res.message);
          //this.showSmallLoader = false;
          if (this.profileFormCom) {
            this.profileFormCom.getUserProfileData(this.userId);
          }
        },
        error: res => {
          this._toastr.error("Error", res.message);
          //this.showSmallLoader = false;
        },
      });
  }

  getProfileFormChanges(event: FormGroup) {
    this.profileForm = event;
    this.isProfileActive = event.get("isProfileActive")?.value;
    this.isProfileValid = this.profileForm.valid;
    this.items = [
      {
        label: "Confirm Email",
        command: () => {
          this.updateUserProfileDataSilent();
        },
        visible: this.profileForm.valid && !this.checkIsSaveButtonDisabled(),
      },
      {
        label: "Refresh Profile",
        command: () => {
          if (this.profileFormCom) {
            this.profileFormCom.refreshProfile();
          }
        },
      },
      {
        label: "Save Profile",
        command: () => {
          if (this.profileFormCom) {
            this.profileFormCom.updateUserProfileData();
          }
        },
      },
      {
        label: "Generate Report",
        command: () => {
          if (this.profileFormCom) {
            this.profileFormCom.generateReport();
          }
        },
        visible: this.checkUserDataForReportVisibility(),
      },
    ];
  }

  onProfileActiveToggleChanges(event: ToggleSwitchChangeEvent) {
    this.profileForm.get("isProfileActive")?.setValue(event.checked);
    this._usersListingService
      .UpdateUserProfileActive({
        id: this.profileForm?.get("id")?.value,
        isProfileActive: event.checked,
      })
      .subscribe(
        (res: GenericResponseDto<{ id: number; IsProfileActive: boolean }>) => {
          if (res.status.toLowerCase() === "success") {
            this._toastr.success(
              "Success",
              `Profile updated to ${event.checked ? "Active" : "Inactive"}`
            );
          } else {
            this._toastr.error("Error", "Error updating profile");
          }
        }
      );
  }

  checkIsSaveButtonDisabled(): boolean {
    if (this.profileFormCom) {
      return this.profileFormCom.disableSaveButton;
    }
    return false;
  }

  checkUserDataForReportVisibility(): boolean {
    if (this.profileFormCom) {
      this.getUserObject = this.profileFormCom.getUserObject;
      if (this.getUserObject) {
        return (
          this.getUserObject?.data?.loginEmail ===
            "portaltestsales@nadel.com" ||
          this.getUserObject?.data?.loginEmail === "Anne.Thiongo@nadel.com"
        );
      }
      return false;
    }

    return false;
  }

  closeSupportUserProfileModal() {
    this.userSupportProfileDisplayModal = false;
  }

  showSupportUserProfileModal(event: number) {
    this.selectedUserId = event;
    this.userSupportProfileDisplayModal = true;
  }

  closeProfileModalStacker() {
    this.emitCloseProfileModal.emit();
  }
}
